import { filter, split } from "lodash"

export function splitIgnoreEmpty(str: string, separator?: RegExp | string, limit?: number) {
    return filter(split(str, separator, limit), x => x.length != 0)
}